import Vue from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/fontglobal.scss";
Vue.use(Element);

import moment from "moment";
Vue.prototype.$moment = moment;
import _ from "lodash";
Vue.prototype.$_ = _;
// 数字滚动
import countTo from "vue-count-to";
Vue.component("countTo", countTo);

Vue.config.productionTip = false;
// echart 字体大小适配
window.nowSize = (val, initWidth = 1920) => {
  const nowClientWidth = document.documentElement.clientWidth;
  // console.log(nowClientWidth)
  // console.log(val * (nowClientWidth / initWidth))
  return val * (nowClientWidth / initWidth);
};
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
}).$mount("#app");
